{
  "tabs": {
    "chat": "چټ",
    "reminders": "یادونې",
    "calendar": "کالینډر",
    "settings": "ترتیبات"
  },
  "common": {
    "cancel": "لغوه کول",
    "save": "خوندي کول",
    "confirm": "تایید",
    "delete": "حذف",
    "back": "شاته",
    "close": "بندول",
    "edit": "سمول",
    "search": "لټون",
    "all": "ټول",
    "loading": "لوډیږي...",
    "error": "یو څه غلط شول",
    "notFound": "نه موندل شو",
    "tryAgain": "مهرباني وکړئ بیا هڅه وکړئ",
    "retry": "بیا هڅه",
    "undo": "بیرته اخیستل",
    "pullToRefresh": "تازه کولو لپاره راکاږئ",
    "justNow": "همدا اوس"
  },
  "auth": {
    "welcome": "FishMemory ته ښه راغلاست",
    "tagline": "ستاسو د WhatsApp د یادونې مرسته کوونکی، اوس ستاسو په جیب کې.",
    "subtitle": "ستاسو د WhatsApp د یادونې مرسته کوونکی، اوس ستاسو په جیب کې.",
    "phoneLabel": "ستاسو د WhatsApp شمېره",
    "phoneHint": "موږ به د WhatsApp له لارې تاییدي کوډ واستوو",
    "invalidPhone": "مهرباني وکړئ یوه باوري تلیفون شمېره دننه کړئ",
    "continue": "دوام ورکړئ",
    "enterPhone": "خپل د WhatsApp شمېره دننه کړئ",
    "phonePlaceholder": "د تلیفون شمېره",
    "sendCode": "کوډ واستوئ",
    "verifyTitle": "خپل شمېره تایید کړئ",
    "otpSentTo": "۶ عددي کوډ {{phone}} ته د WhatsApp له لارې واستول شو",
    "enterFullCode": "مهرباني وکړئ ټول ۶ عددونه دننه کړئ",
    "invalidOtp": "ناسم کوډ. مهرباني وکړئ بیا هڅه وکړئ.",
    "otpFailed": "کوډ لیږل ناکام شول. بیا هڅه وکړئ.",
    "otpResent": "کوډ بیا واستول شو",
    "resendIn": "{{seconds}} ثانیې کې بیا واستوئ",
    "resendCode": "کوډ بیا واستوئ",
    "enterOtp": "هغه کوډ دننه کړئ چې ستاسو WhatsApp ته واستول شو",
    "verify": "تایید",
    "resend": "کوډ بیا واستوئ",
    "wrongNumber": "غلط شمېره؟",
    "backToPhone": "بېرته تلیفون ته",
    "editPhone": "د تلیفون شمېره سمول",
    "error": "تېروتنه",
    "setupTitle": "راځئ چې ترتیب وکړو",
    "setupSubtitle": "تاسو کولی شئ دا وروسته په ترتیباتو کې بدل کړئ",
    "namePlaceholder": "ستاسو نوم",
    "letsGo": "ترتیب بشپړ کړئ",
    "skipForNow": "اوس لپاره پریږدئ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "پیغام ولیکئ...",
    "inputPlaceholder": "پیغام ولیکئ...",
    "typing": "FishMemory لیکي...",
    "online": "آنلاین",
    "connecting": "نښلول...",
    "reconnecting": "بیا نښلول...",
    "offline": "آفلاین",
    "empty": "یو خبرې اترې پیل کړئ",
    "emptyHint": "یادونې جوړې کړئ، خپل مهالویش وګورئ، یا مرسته وغواړئ.",
    "emptyAction": "نمونې یادونه واستوئ",
    "actions": "د چټ کړنې",
    "keep": "پیغامونه وساتئ",
    "clearTitle": "چټ پاک کړئ",
    "clearConfirm": "ټول پیغامونه له دې وسیلې څخه حذف کړئ؟ دا نه شي بیرته کیدای.",
    "clear": "چټ پاک کړئ",
    "optionSelected": "ټاکل شوی: {{label}}",
    "sendingSelection": "لیږل...",
    "connectionLost": "بیا نښلول..."
  },
  "reminders": {
    "title": "زما یادونې",
    "active": "فعال",
    "today": "نن",
    "thisWeek": "دا اونۍ",
    "history": "تاریخچه",
    "items": "توکي",
    "emptyTitle": "تر اوسه یادونې نشته",
    "emptySubtitle": "له چټ څخه یوه جوړه کړئ او دلته به ښکاره شي.",
    "emptyAction": "چټ خلاص کړئ",
    "filterActive": "فعال",
    "filterToday": "نن",
    "filterWeek": "دا اونۍ",
    "filterHistory": "تاریخچه",
    "emptyState": "تر اوسه یادونې نشته. خبرې پیل کړئ!",
    "swipeDone": "شو",
    "swipeSnooze": "وځنډوئ",
    "swipeDelete": "حذف",
    "search": "یادونې ولټوه...",
    "upcoming": "راتلونکې",
    "completed": "بشپړ شوي",
    "overdue": "ناوخته",
    "tomorrow": "سبا",
    "synced": "همغږی شوی {{value}}",
    "swipeHint": "د نورو کړنو لپاره یادونه وڅنډوئ",
    "noResults": "هیڅ یادونه ستاسو د لټون سره نه مطابقت کوي",
    "noResultsHint": "بل کلیدي ټکی وکاروئ یا لټون پاک کړئ",
    "deleteAllFailed": "ټولې یادونې حذف کول ناکام شول"
  },
  "calendar": {
    "title": "کالینډر",
    "today": "نن",
    "tomorrow": "سبا",
    "completed": "شو",
    "noEvents": "هیڅ مهالویش نشته",
    "noEventsSubtitle": "د یادونو او پیښو لیدلو لپاره نیټه وټاکئ.",
    "googleEvent": "Google Calendar",
    "legendActive": "فعال",
    "legendRecurring": "تکراري",
    "legendDone": "شو",
    "legendGoogle": "Google",
    "previousMonth": "تېر میاشت",
    "nextMonth": "راتلونکې میاشت",
    "previousYear": "تېر کال",
    "nextYear": "راتلونکی کال",
    "goToToday": "نن ته لاړ شئ",
    "all": "ټول",
    "active": "فعال",
    "done": "شو",
    "paused": "تم شوی"
  },
  "settings": {
    "title": "ترتیبات",
    "profile": "پروفایل",
    "name": "د نندارې نوم",
    "enterName": "خپل نوم دننه کړئ",
    "language": "ژبه",
    "uiLanguage": "د اپلیکیشن ژبه",
    "uiLanguageHelp": "یوازې د دې وسیلې لپاره د اپ UI، کالینډر لیبلونه، او ترتیب بدلوي.",
    "serverLanguage": "د چټ ژبه",
    "serverLanguageHelp": "ستاسو د حساب لپاره د سرور ځوابونو او یادونې پیغامونو ژبه بدلوي.",
    "timezone": "وخت زون",
    "currentTimezone": "اوسنی وخت زون",
    "timezoneHelp": "ټولې د یادونې وختونه په دې وخت زون کې ښودل کیږي.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "وخت زون خوندي کړئ",
    "timezoneSaved": "وخت زون تازه شو",
    "detect": "موندل",
    "detectFailed": "وخت زون ونه موندل شو",
    "autoDetect": "د GPS څخه اوتومات موندل",
    "notifications": "خبرتیاوې",
    "notificationsHelp": "وروستي یادونې د یادونې وروسته تکراري خبرداری کنټرولوي. د وسیلې کچه خبرتیا اجازه لا هم په تلیفون ترتیباتو کې اداره کیږي.",
    "pushEnabled": "پش خبرتیاوې",
    "autoDoneOnFire": "کله چې فعال شي اوتومات بشپړ نښه کول",
    "autoDoneOnFireDesc": "که بند وي، یادونې تر هغه پورې فعال پاتې کیږي تر څو چې تاسو یې بشپړ نښه کړئ.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "نښلول شوی",
    "googleDisconnected": "نښلول شوی نه دی",
    "googleConnectedHelp": "نوې یادونې کولی شي په اوتومات ډول ستاسو کالینډر سره همغږي شي.",
    "googleDisconnectedHelp": "Google Calendar ونښلوئ ترڅو یادونې او پیښې سمې پاتې شي.",
    "googleConnectFailed": "د Google Calendar نښلول ناکام شول",
    "connected": "نښلول شوی",
    "disconnected": "نښلول شوی نه دی",
    "connect": "نښلول",
    "disconnect": "قطع کول",
    "autoSync": "نوې یادونې اوتومات همغږي کړئ",
    "autosync": "نوې یادونې اوتومات همغږي کړئ",
    "subscription": "سبسکرپشن",
    "trialUsed": "آزموینه: {{used}}/{{total}} کارول شوې",
    "trialStatus": "آزموینه موجوده ده",
    "activeStatus": "فعال سبسکرپشن",
    "expiredStatus": "سبسکرپشن پای ته رسیدلی",
    "unsubscribedStatus": "سبسکرایب شوی نه دی",
    "about": "په اړه",
    "version": "نسخه",
    "logout": "وتل",
    "logoutTitle": "وتل",
    "logoutConfirm": "تاسو ډاډه یاست چې غواړئ ووځئ؟",
    "noName": "نوم نه دی ټاکل شوی",
    "serverConnection": "د سرور اړیکه",
    "serverUrl": "د سرور URL",
    "serverEdit": "سمول",
    "saveReconnect": "خوندي کول او بیا نښلول",
    "resetDefault": "اصلي ته بیا تنظیمول",
    "invalidServerUrlTitle": "ناسم سرور URL",
    "invalidServerUrlMessage": "مهرباني وکړئ یو باوري http یا https سرور URL دننه کړئ، لکه https://example.com",
    "uiLanguageChangeFailed": "د اپلیکیشن ژبه بدلول ناکام شول. مهرباني وکړئ بیا هڅه وکړئ.",
    "serverLanguageChangeFailed": "د چټ ژبه بدلول ناکام شول. مهرباني وکړئ بیا هڅه وکړئ.",
    "timezoneChangeFailed": "د وخت زون بدلول ناکام شول. مهرباني وکړئ بیا هڅه وکړئ.",
    "autoSyncChangeFailed": "د اوتومات همغږي تازه کول ناکام شول. مهرباني وکړئ بیا هڅه وکړئ.",
    "nameChangeFailed": "د نندارې نوم تازه کول ناکام شول. مهرباني وکړئ بیا هڅه وکړئ.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "د یادونې تفصیلات",
    "editTime": "وخت سمول",
    "rename": "نوم بدلول",
    "snooze": "وځنډوئ",
    "snooze15": "۱۵ دقیقې ځنډول",
    "pause": "تم کول",
    "pauseReminder": "یادونه تم کړئ",
    "resume": "بیا پیل",
    "resumeReminder": "یادونه بیا پیل کړئ",
    "skip": "راتلونکی پریږدئ",
    "skipOccurrence": "دا ځل پریږدئ",
    "syncGoogle": "Google سره همغږي کړئ",
    "delete": "حذف",
    "deleteTitle": "یادونه حذف کړئ",
    "deleteConfirm": "دا یادونه به په تل پاتې ډول حذف شي.",
    "deleteRecurringTitle": "تکراري یادونه حذف کړئ",
    "deleteRecurringMessage": "ایا غواړئ دا ځل پریږدئ یا ټول لړۍ حذف کړئ؟",
    "deleteThisOccurrence": "دا ځل پریږدئ",
    "deleteEntireSeries": "ټوله لړۍ حذف کړئ",
    "done": "شو",
    "markDone": "بشپړ نښه کړئ",
    "undo": "بیرته راوړل",
    "undoPrompt": "بیا فعالول غواړئ؟ اوس یې بیرته راوړئ.",
    "recurring": "تکراري",
    "nextRun": "راتلونکی ځل",
    "oneTime": "یو ځل",
    "pending": "په تمه",
    "sent": "لیږل شوی",
    "paused": "تم شوی",
    "active": "فعال",
    "snoozed": "ځنډول شوی",
    "localTime": "په ستاسو محلي وخت ښودل شوی",
    "recurrence": "تکرار",
    "created": "جوړ شوی",
    "tags": "ټګونه",
    "fireCount": "ځلې فعال شوی",
    "actions": "کړنې",
    "none": "هیڅ",
    "snoozeFailed": "د یادونې ځنډول ناکام شول",
    "pauseFailed": "د یادونې تم کول ناکام شول",
    "resumeFailed": "د یادونې بیا پیل ناکام شو",
    "skipFailed": "د یادونې پریښودل ناکام شول",
    "doneFailed": "د یادونې بشپړ نښه کول ناکام شول",
    "undoFailed": "د یادونې حالت بیرته راوړل ناکام شول",
    "deleteFailed": "د یادونې حذف ناکام شو",
    "rescheduleTitle": "بیا مهالویش کول؟",
    "rescheduleMsg": "دا یادونه ناوخته ده. غواړئ بیا مهالویش یې کړئ؟",
    "reschedule15": "په ۱۵ دقیقو کې",
    "reschedule60": "په ۱ ساعت کې",
    "keepOverdue": "همداسې وساتئ"
  },
  "onboarding": {
    "slide1Title": "FishMemory ته ښه راغلاست",
    "slide1Sub": "ستاسو شخصي یادونې مرسته کوونکی — د WhatsApp ځواکمن شوی او ستاسو د جیب لپاره جوړ شوی.",
    "slide2Title": "فقط طبیعي خبرې وکړئ",
    "slide2Sub": "یادونې داسې ولیکئ لکه څنګه چې فکر کوئ: «سبا په ۳ بجو مور ته زنګ ووهم» — موږ پاتې کار کوو.",
    "slide3Title": "هیڅ شی مه هېروئ",
    "slide3Sub": "په وخت خبرتیاوې ترلاسه کړئ، د ټګونو سره تنظیم کړئ، او هر څه په کنټرول کې وساتئ.",
    "getStarted": "پیل کړئ",
    "next": "راتلونکی",
    "firstReminderTitle": "خپله لومړۍ یادونه جوړه کړئ!",
    "firstReminderHint": "کوشش وکړئ داسې څه ولیکئ:",
    "firstReminderExample": "ما ته یادونه وکړه چې سبا په ۹ بجو اوبه وڅښم",
    "gotIt": "سمه ده!",
    "notifRationaleTitle": "په وخت پاتې شئ",
    "notifRationaleBody": "FishMemory ته اړتیا ده چې خبرتیاوې واستوي ترڅو تاسو په وخت یادونه وکړي. تاسو به یوازې د هغو یادونو لپاره خبرداری ترلاسه کړئ چې تاسو یې جوړوئ.",
    "notifRationaleAllow": "خبرتیاوې فعال کړئ",
    "notifRationaleLater": "شاید وروسته",
    "swipeHint": "د چټکو کړنو لپاره ښي خوا ته وڅنډئ →",
    "calendarDragHint": "د پراخولو لپاره وکاږئ ↕"
  }
}
